export default __webpack_public_path__ + "media/vendor/paper-dashboard-2-pro-html-v2.0.1/assets/img/flags/SL-daf195bf0464b73d7963b46bbed89653.png";